export default __webpack_public_path__ + "static/media/postgress_black.c3def67e.png";